import { useRef, useState } from 'react';
import { View, TouchableOpacity } from 'react-native';

import { Avatar, Button, COLORS, HRule, Text, TextField } from '../Basics';

const PRESET_AVATARS = [
  '/assets/avatars/preset-1.svg',
  '/assets/avatars/preset-2.svg',
  '/assets/avatars/preset-3.svg'
];

export const AvatarForm = ({ nickname = '', avatar, onChange }) => {
  const [url, setUrl] = useState(avatar || '');
  const fileRef = useRef(null);

  const apply = value => {
    setUrl(value);
    onChange?.(value);
  };

  const onFile = async ev => {
    const file = ev.target?.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return;

    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') apply(reader.result);
    };
    reader.readAsDataURL(file);
    ev.target.value = '';
  };

  return (
    <View>
      <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 8, color: COLORS.textPrimary }}>
        Avatar
      </Text>

      <View style={{ alignItems: 'center', marginBottom: 12 }}>
        <Avatar name={nickname} imageUrl={url} size={72} />
      </View>

      <TextField
        placeholder="https://... ou cole URL da foto"
        value={url.startsWith('data:') ? '' : url}
        onChange={val => apply(val)}
        style={{ marginBottom: 8 }}
      />

      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={onFile}
      />

      <View style={{ flexDirection: 'row', gap: 8, marginBottom: 8 }}>
        <Button color="primary" onClick={() => fileRef.current?.click()}>
          <Text style={{ color: '#fff', fontSize: 12 }}>Enviar imagem</Text>
        </Button>
        {url ? (
          <Button
            onClick={() => apply('')}
            style={{ backgroundColor: 'transparent', borderWidth: 1, borderColor: COLORS.borderColor }}
          >
            <Text style={{ fontSize: 12, color: COLORS.textPrimary }}>Remover</Text>
          </Button>
        ) : null}
      </View>

      <Text
        style={{ fontSize: 11, color: COLORS.textSecondary, marginBottom: 6 }}
      >
        Presets Lorentz
      </Text>
      <View style={{ flexDirection: 'row', gap: 10 }}>
        {PRESET_AVATARS.map(src => (
          <TouchableOpacity key={src} onPress={() => apply(src)}>
            <Avatar name="" imageUrl={src} size={40} />
          </TouchableOpacity>
        ))}
      </View>

      <HRule />
    </View>
  );
};

export default AvatarForm;
